import script from "./CameraSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./CameraSetting.vue?vue&type=script&setup=true&lang=js"

import "./CameraSetting.vue?vue&type=style&index=0&id=dc1e6558&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc1e6558"]])

export default __exports__